var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaper = function SvgPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M6.75 3a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm-3 1.5a3 3 0 0 1 3-3h10.5a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M7.5 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 6M7.5 9.75A.75.75 0 0 1 8.25 9h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M7.5 13.5a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H8.25a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgPaper;